function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.114,
    height: 20,
    viewBox: "0 0 18.114 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.067 20.482h15c.966 0 1.557-.525 1.557-1.313 0-.994-.9-1.848-1.745-2.655a4.868 4.868 0 0 1-.872-2.861 19.807 19.807 0 0 0-.15-1.745 4.2 4.2 0 0 1-1.613.328 4.574 4.574 0 0 1-4.55-4.559 4.517 4.517 0 0 1 1.154-3.011 2.715 2.715 0 0 0-1.285-.319 2.958 2.958 0 0 0-2.8 2.2c-2.42.872-3.433 3.293-3.574 6.726-.122 1.248-.281 2.6-.938 3.246-.844.807-1.745 1.66-1.745 2.655.004.782.594 1.308 1.561 1.308zm12.186-9.569a3.236 3.236 0 1 0-3.236-3.236 3.261 3.261 0 0 0 3.236 3.236zm-4.681 13.434a2.911 2.911 0 0 0 2.992-2.547H11.57a2.914 2.914 0 0 0 3.002 2.547z",
    transform: "translate(-5.51 -4.347)",
    style: {}
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b5d2f5a1.svg";
export { ForwardRef as ReactComponent };